import { render, staticRenderFns } from "./BnAvoir.vue?vue&type=template&id=2c8a4508&"
import script from "./BnAvoir.vue?vue&type=script&lang=js&"
export * from "./BnAvoir.vue?vue&type=script&lang=js&"
import style0 from "./BnAvoir.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports